import { render, staticRenderFns } from "./Migrations.vue?vue&type=template&id=236c6046&"
import script from "./Migrations.vue?vue&type=script&lang=js&"
export * from "./Migrations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports